<div class="card">
  <app-header
    titulo="Provedores"
    descricao="Gerenciamento de provedores de dados (Bancos de Dados e APIs REST)">
  </app-header>

  <p-table
    #dt
    [value]="provedores"
    dataKey="id"
    [loading]="loading"
    [globalFilterFields]="['nome', 'descricao', 'tipo', 'criadoPor']"
    styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
    [paginator]="true"
    [rows]="20"
    [rowsPerPageOptions]="[10, 20, 50, 100]"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
    [scrollable]="true"
    scrollHeight="500px">

    <!-- Caption com ações -->
    <ng-template pTemplate="caption">
      <div class="flex align-items-center justify-content-between">
        <div class="flex align-items-center">
          <button
            pButton
            pRipple
            label="Novo Provedor"
            icon="pi pi-plus"
            class="p-button-success mr-2"
            (click)="novoProvedor()">
          </button>
          <button
            pButton
            pRipple
            icon="pi pi-filter-slash"
            class="p-button-outlined"
            (click)="limparFiltros()"
            pTooltip="Limpar filtros"
            tooltipPosition="top">
          </button>
        </div>

        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input
            pInputText
            type="text"
            (input)="dt.filterGlobal($any($event.target)?.value, 'contains')"
            placeholder="Pesquisar..."
            class="w-full" />
        </span>

        <button
          pButton
          pRipple
          icon="pi pi-refresh"
          class="p-button-outlined"
          (click)="carregarProvedores()"
          [loading]="loading"
          pTooltip="Atualizar"
          tooltipPosition="top">
        </button>
      </div>
    </ng-template>

    <!-- Header -->
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="nome" style="min-width: 200px;">
          Nome
          <p-sortIcon field="nome"></p-sortIcon>
        </th>
        <th pSortableColumn="tipo" style="width: 150px;">
          Tipo
          <p-sortIcon field="tipo"></p-sortIcon>
        </th>
        <th pSortableColumn="descricao" style="min-width: 250px;">
          Descrição
          <p-sortIcon field="descricao"></p-sortIcon>
        </th>
        <th pSortableColumn="criadoPor" style="width: 150px;">
          Criado Por
          <p-sortIcon field="criadoPor"></p-sortIcon>
        </th>
        <th pSortableColumn="dtCriado" style="width: 150px;">
          Data Criação
          <p-sortIcon field="dtCriado"></p-sortIcon>
        </th>
        <th style="width: 180px; text-align: center;">
          Ações
        </th>
      </tr>
    </ng-template>

    <!-- Body -->
    <ng-template pTemplate="body" let-provedor>
      <tr>
        <td>
          <strong>{{ provedor.nome }}</strong>
        </td>
        <td>
          <p-tag
            [value]="getTipoLabel(provedor.tipo)"
            [severity]="getTipoSeverity(provedor.tipo)"
            [icon]="provedor.tipo === TipoProvedor.BASEDADOS ? 'pi pi-database' : 'pi pi-globe'">
          </p-tag>
        </td>
        <td>{{ provedor.descricao }}</td>
        <td>{{ provedor.criadoPor }}</td>
        <td>{{ provedor.dtCriado | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td class="text-center">
          <button
            pButton
            pRipple
            icon="pi pi-link"
            class="p-button-rounded p-button-info p-button-text mr-1"
            (click)="gerenciarConexoes(provedor)"
            pTooltip="Gerenciar Conexões"
            tooltipPosition="top">
          </button>
          <button
            pButton
            pRipple
            icon="pi pi-pencil"
            class="p-button-rounded p-button-warning p-button-text mr-1"
            (click)="editarProvedor(provedor)"
            pTooltip="Editar"
            tooltipPosition="top">
          </button>
          <button
            pButton
            pRipple
            icon="pi pi-trash"
            class="p-button-rounded p-button-danger p-button-text"
            (click)="deletarProvedor(provedor)"
            pTooltip="Deletar"
            tooltipPosition="top">
          </button>
        </td>
      </tr>
    </ng-template>

    <!-- Empty message -->
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6" class="text-center">
          <div class="text-gray-500 py-5">
            <i class="pi pi-info-circle text-4xl mb-3"></i>
            <p class="text-xl mb-2">Nenhum provedor cadastrado</p>
            <p class="text-sm mb-3">Comece criando seu primeiro provedor de dados</p>
            <button
              pButton
              pRipple
              label="Criar Primeiro Provedor"
              icon="pi pi-plus"
              class="p-button-success"
              (click)="novoProvedor()">
            </button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- Confirm Dialog -->
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>
</div>
